import { useNavigate, useParams } from '@tanstack/react-router';
import { ShoppingModeScreen } from '@mrrmlab/feature-shopping-list';

export function ListShoppingModeRoute() {
  const { listId } = useParams({ from: '/lists/$listId/einkaufen' });
  const navigate = useNavigate();
  return (
    <ShoppingModeScreen
      listId={listId}
      onExit={() =>
        navigate({ to: '/lists/$listId', params: { listId } })
      }
    />
  );
}
